<template lang="pug">
  a.arrowbutton(v-on:click.prevent="goDown")
    ArrowIcon
</template>
<script>
import ArrowIcon from '@/components/transition/ArrowIcon'

export default {
  components: {
    ArrowIcon
  },
  methods: {
    goDown() {
      window.scrollTo({
        top: window.innerHeight,
        behavior: 'smooth'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  a{
    display: block;
    padding: 0.8rem;
    cursor: pointer;
    animation: bounce 3s infinite;
  }
  @keyframes bounce {
    0%, 18%, 25%, 30%, 50%, 55%, 100% {
      transform: translateY(0);
    }
    22% {
      transform: translateY(20px);
    }
    33% {
      transform: translateY(5px);
    }
  }
</style>


